export const customDataTableStyle = {
  headRow: {
    style: {
      minHeight: "36px",
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  headCells: {
    style: {
      minHeight: "36px",
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  cells: {
    style: {
      minHeight: "36px",
      paddingLeft: "8px",
      paddingRight: "8px",
      overflow: "hidden",
    },
  },
  rows: {
    style: {
      minHeight: "36px",
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
};

const usersTableStyle = {
  headRow: {
    style: {},
  },
  headCells: {
    style: {},
  },
  cells: {
    style: {},
  },
  rows: {
    style: {
      // border: "1px solid lightgray",
    },
  },
};

export const portfolioCustomDataTableStyle = {
  headRow: {
    style: {
      backgroundColor: "rgb(241, 241, 241)",
      border: "1px solid #efefef8b",
      fontSize: "1.2em",
      fontWeight: "600",
    },
  },
  rows: {
    style: {
      border: "1px solid lightgray",
    },
  },
};

export const taskCustomDataTableStyle = {
  headRow: {
    style: {
      backgroundColor: "rgb(241, 241, 241)",
      border: "1px solid #efefef8b",
      fontSize: "1.2em",
      fontWeight: "600",
      minHeight: "36px",
      maxHeight: "36px",
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  headCells: {
    style: {
      minHeight: "36px",
      maxHeight: "36px",
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  cells: {
    style: {
      minHeight: "36px",
      maxHeight: "36px",
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  rows: {
    style: {
      border: "1px solid lightgray",
      minHeight: "36px",
      maxHeight: "36px",
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  pagination: {
    style: {
      minHeight: "32px", // Reducing the height
      maxHeight: "32px", // Reducing the height
      fontSize: "0.85em", // Smaller font size
      padding: "8px", // Adjust padding as needed
    },
    pageButtonsStyle: {
      borderRadius: "50%", // Circular buttons
      height: "30px", // Smaller buttons
      width: "30px", // Smaller buttons
      padding: "4px", // Adjust padding as needed
      margin: "padding: 2px", // Space between buttons
    },
  },
};

export const UserRolesTableStyle = {
  table: {
    style: {
      borderCollapse: "collapse", // Ensures borders are shared between adjacent cells
    },
  },
  rows: {
    style: {
      borderBottom: "none",
    },
  },
  headRow: {
    style: {
      borderRight: "1px solid #E0E0E0",
    },
  },
  headCells: {
    style: {
      borderTop: "1px solid #E0E0E0", // Adds border to header cells
      boxSizing: "border-box",
    },
  },
  cells: {
    style: {
      border: "1px solid #E0E0E0", // Adds border to body cells
      boxSizing: "border-box",
      borderBottom: "none",
      wordBreak: "break-word",
    },
  },
  expanderCell: {
    style: {
      borderRight: "none",
      borderBottom: "none",
    },
  },
};
